function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 21,
  cy: 21,
  r: 21,
  fill: "#eeeff3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_251",
  "data-name": "Group 251",
  transform: "translate(11 11)"
}, /*#__PURE__*/React.createElement("g", {
  id: "intake",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  d: "M8.746,10.066H7.391a.575.575,0,0,0-.49.631v1.073a.577.577,0,0,0,.49.631H8.746a.575.575,0,0,0,.49-.631V10.7A.589.589,0,0,0,8.746,10.066Zm-4.088,0H3.3a.575.575,0,0,0-.49.631v1.073a.577.577,0,0,0,.49.631H4.658a.575.575,0,0,0,.49-.631V10.7A.589.589,0,0,0,4.658,10.066Zm4.088-3.5H7.391a.575.575,0,0,0-.49.631V8.267a.577.577,0,0,0,.49.631H8.746a.575.575,0,0,0,.49-.631V7.194A.589.589,0,0,0,8.746,6.562Zm-4.088,0H3.3a.575.575,0,0,0-.49.631V8.267A.577.577,0,0,0,3.3,8.9H4.658a.575.575,0,0,0,.49-.631V7.194A.589.589,0,0,0,4.658,6.562Zm8.176,0H11.479a.575.575,0,0,0-.49.631V8.267a.577.577,0,0,0,.49.631h1.356a.575.575,0,0,0,.49-.631V7.194A.589.589,0,0,0,12.834,6.562Z",
  transform: "translate(0.691 1.613)",
  fill: "#f6b900",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  d: "M17.095,11.59V3.629a2.026,2.026,0,0,0-.512-1.343v-.02h-.02a1.992,1.992,0,0,0-1.5-.682H13.593v-.9A.67.67,0,0,0,12.924,0h-1a.67.67,0,0,0-.669.682v.9H5.823v-.9A.67.67,0,0,0,5.154,0h-1a.67.67,0,0,0-.669.682v.9H2.007a1.992,1.992,0,0,0-1.5.682v.02A2.026,2.026,0,0,0,0,3.629V14.557A2.035,2.035,0,0,0,2.007,16.6h9.423a3.839,3.839,0,0,0,3.4,2.085,3.936,3.936,0,0,0,2.262-7.1Zm-6.118,3.168a3.972,3.972,0,0,0,.039.481H2.007a.67.67,0,0,1-.669-.682V6.216h14.4v4.732a3.4,3.4,0,0,0-.9-.12A3.9,3.9,0,0,0,10.977,14.758Zm5.449-.4L14.832,16.1a.516.516,0,0,1-.748,0l-.944-1.043a.516.516,0,0,1,.02-.722.493.493,0,0,1,.708.02l.59.642,1.22-1.343a.493.493,0,0,1,.708-.02A.5.5,0,0,1,16.426,14.357Z",
  transform: "translate(0)",
  fill: "#f6b900"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_114",
  "data-name": "Rectangle 114",
  width: 20,
  height: 20,
  fill: "none"
}));

var SvgCalendarYellow = function SvgCalendarYellow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_433",
    "data-name": "Group 433",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-yellow.a1a85d60.svg";
export { ForwardRef as ReactComponent };